import { legacySizes } from '~/constants/common/resizeBreakpoints';
import { useResizeListener, useTrackClickEvents } from '~/hooks/common';
import useDataDogRUM from '~/hooks/common/useDataDogRUM';
import useSendViewedEvent from '~/hooks/common/useSendViewedEvent';
import useSynchronizeAuth from '~/hooks/common/useSynchronizeAuth';

export default function SemData() {
  useDataDogRUM();
  useSynchronizeAuth();
  useSendViewedEvent('ViewedPage - SEM Landing');
  useResizeListener(legacySizes);
  useTrackClickEvents();

  return null;
}
